module.exports = __webpack_public_path__ + "static/media/pf14.52caa242.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf14.png
// module id = 2656
// module chunks = 0